import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";
import { RegisterFcmToken } from "../../Redux/Notifications/NotificationsAction";
import { toast } from "sonner";

// Firebase configuration, given by firebase
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWq1wusX1V_3rH55lQjWQQdXWzZsG8PTw",
  authDomain: "onlyfunds-firebase.firebaseapp.com",
  projectId: "onlyfunds-firebase",
  storageBucket: "onlyfunds-firebase.firebasestorage.app",
  messagingSenderId: "128542928816",
  appId: "1:128542928816:web:f81fb83cd472c195a5f075",
  measurementId: "G-VDDGSEL0Z2",
};
// Initialize the firebase app
const firebaseApp = initializeApp(firebaseConfig);

// Get the messaging instance from the firebase app
const messaging = getMessaging(firebaseApp);

// Function to set up notifications
const setupNotifications = async (dispatch) => {
  try {
    if (!("Notification" in window)) {
      console.error("This browser does not support notifications.");
      return;
    }

    // console.log("Notification permission:", Notification.permission);
    // console.log("VAPID Key:", process.env.REACT_APP_VAPID_KEY);

    const permission = Notification.permission;

    if (permission === "granted") {
      console.log("starting");
      let token;
      try {
        token = await getToken(messaging, {
          vapidKey:
            process.env.REACT_APP_VAPID_KEY || "YOUR_PUBLIC_VAPID_KEY_HERE",
        });
      } catch (error) {
        console.log("Error getting token", error);
      }
      console.log(token);
      if (token) {
        console.log("FCM Token:", token);
        localStorage.setItem("fcm_token", token);
      }
    } else if (permission === "default") {
      const userConsent = await Notification.requestPermission();
      if (userConsent === "granted") {
        const token = await getToken(messaging, {
          vapidKey:
            process.env.REACT_APP_VAPID_KEY || "YOUR_PUBLIC_VAPID_KEY_HERE",
        });
        if (token) {
          console.log("FCM Token:", token);
          localStorage.setItem("fcm_token", token);
        }
      } else {
        console.warn("User denied notification permissions.");
      }
    } else {
      console.warn(
        "Notifications are blocked. Please enable them in settings."
      );
    }

    // Listener for notifications when the app is in the foreground
    onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload);
      toast(payload.data?.title || "New notification received!");
    });
  } catch (error) {
    console.error("Error setting up notifications:", error);
  }
};

export { messaging, setupNotifications };
